<form [formGroup]="feeStructureForm" (ngSubmit)="onSubmit()" novalidate>
    <div class="flex items-center justify-center dialog-header">
        {{ type }} Fee Structure
        <div class="absolute right-2">
            <button (click)="handleCloseDialog()" type="button" class="outline-none p-5">
                <i class="pi pi-times"></i>
            </button>
        </div>
    </div>

    <div class="dialog-content" style="margin-top: -15px;">

        <!-- Fee Name -->
        <div class="field">
            <label class="requiredValue">Fee Name</label>
            <input pInputText formControlName="fee_name" placeholder="Enter Fee Name" />
            <small *ngIf="feeStructureForm.get('fee_name')?.invalid && isSubmitted" class="p-error">
                Fee Name is required
            </small>
        </div>

        <!-- Amount -->

        <div class="field">
            <label class="requiredValue">Amount</label>
            <input pInputText type="number" formControlName="amount" placeholder="Enter Amount" />
            <small *ngIf="feeStructureForm.get('amount')?.invalid && isSubmitted" class="p-error">
                Amount is required
            </small>
        </div>

        <!-- Action buttons -->
        <div class="flex justify-end gap-2 mt-8">
            <p-button label="Cancel" severity="danger" variant="outlined" (click)="handleCloseDialog()"
                type="button"></p-button>
            <p-button label="Save" icon="pi pi-save" [loading]="btnLoading" [disabled]="btnLoading"
                type="submit"></p-button>
        </div>
    </div>
</form>